import React from 'react';
import { Button } from 'antd';
import { ReloadOutlined, WarningOutlined } from '@ant-design/icons';

import './app-error.css';

export interface SectionErrorStateProps {
  title?: string;
  description: string;
  onRetry?: () => void;
  retryLabel?: string;
  compact?: boolean;
}

const SectionErrorState: React.FC<SectionErrorStateProps> = ({
  title = 'Não foi possível carregar os dados',
  description,
  onRetry,
  retryLabel = 'Tentar novamente',
  compact = false,
}) => {
  const rootClass = compact
    ? 'section-error-state section-error-state--compact'
    : 'section-error-state';

  return (
    <div className={rootClass} role="alert">
      <div className="section-error-state__icon-wrap">
        <WarningOutlined className="section-error-state__icon" aria-hidden />
      </div>
      <h2 className="section-error-state__title">{title}</h2>
      <p className="section-error-state__description">{description}</p>
      {onRetry ? (
        <Button
          type="default"
          icon={<ReloadOutlined />}
          onClick={onRetry}
          className="section-error-state__retry"
        >
          {retryLabel}
        </Button>
      ) : null}
    </div>
  );
};

export default SectionErrorState;
